<script setup>
import { useAttrs, computed } from 'vue';
import { useMapGetter } from 'dashboard/composables/store';
import boostailLogoLong from 'dashboard/assets/images/boostail-logo-long.svg';
import boostailLogoShort from 'dashboard/assets/images/boostail-logo-short.svg';

const props = defineProps({
  variant: {
    type: String,
    default: 'short', // 'short' | 'long'
    validator: value => ['short', 'long'].includes(value),
  },
});

const attrs = useAttrs();
const globalConfig = useMapGetter('globalConfig/get');

const showCustomLogo = computed(() => {
  return props.variant === 'short' && globalConfig.value.logoThumbnail;
});

const logoSrc = computed(() => {
  return props.variant === 'long' ? boostailLogoLong : boostailLogoShort;
});
</script>

<template>
  <img
    v-if="showCustomLogo"
    v-bind="attrs"
    :src="globalConfig.value.logoThumbnail"
    alt="Logo"
  />
  <img
    v-else
    v-bind="attrs"
    :src="logoSrc"
    alt="BoosTail"
    class="h-full w-auto"
  />
</template>
